import { CalendarRange } from 'lucide-react';
import { useEffect, useState } from 'react';
import { buildDateRangeFilterValue, resolveDateRangeFilterDates } from './date-range-filter-utils';
import { BottomBarActionButtonV2 } from '../../bottom-action-bar-v2';
import { FormDatePickerV2 } from '../../form-field-v2/date-picker';
import { DialogV2 } from '../../dialog-v2';

interface DateRangeFilterDialogProps {
  open: boolean;
  value: string;
  onClose: () => void;
  onApply: (value: string) => void;
}

export const DateRangeFilterDialog = ({ open, value, onClose, onApply }: DateRangeFilterDialogProps) => {
  const initialDates = resolveDateRangeFilterDates(value);
  const [fromDate, setFromDate] = useState(initialDates.fromDate);
  const [toDate, setToDate] = useState(initialDates.toDate);

  useEffect(() => {
    if (!open) return;

    const nextDates = resolveDateRangeFilterDates(value);
    setFromDate(nextDates.fromDate);
    setToDate(nextDates.toDate);
  }, [open, value]);

  const hasInvalidRange = !fromDate || !toDate || fromDate > toDate;

  const handleApply = () => {
    const filterValue = buildDateRangeFilterValue(fromDate, toDate);

    if (!filterValue) return;

    onApply(filterValue);
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc ngày từ đến'
      titleIcon={<CalendarRange className='size-4 text-main' />}
      showFullscreenToggle={false}
      maxWidth='sm'
      paperClassName='w-[560px]'
      actions={
        <>
          <BottomBarActionButtonV2 onClick={handleApply} icon={884} title='Đồng ý' disabled={hasInvalidRange} />
          <BottomBarActionButtonV2 onClick={onClose} icon={885} title='Hủy' primary={false} />
        </>
      }
    >
      <div className='flex min-h-[74px] items-center gap-3 px-5 py-4'>
        <span className='w-24 shrink-0 text-sm font-medium'>Ngày từ/đến</span>
        <FormDatePickerV2
          id='erp-date-filter-from'
          value={fromDate}
          onValueChange={nextValue => setFromDate(nextValue || '')}
          invalid={hasInvalidRange}
          className='min-w-0 flex-1'
        />
        <FormDatePickerV2
          id='erp-date-filter-to'
          value={toDate}
          onValueChange={nextValue => setToDate(nextValue || '')}
          invalid={hasInvalidRange}
          className='min-w-0 flex-1'
        />
      </div>
      {fromDate && toDate && fromDate > toDate ? (
        <p className='px-5 pb-3 text-right text-xs text-red-600'>Ngày từ không được lớn hơn ngày đến</p>
      ) : null}
    </DialogV2>
  );
};
